import { useAuthentication } from '@cp-shared-15/frontend-ui';
import { useTranslation } from 'react-i18next';
import { HookPageRedirectionPath } from '../components/navigation/paths';
import { idpHint } from '../config';

export function useLogin(pathFn: () => string = HookPageRedirectionPath): () => Promise<void> {
    const { login } = useAuthentication();
    const { i18n } = useTranslation();
    const locale = i18n.languages[0];

    return (): Promise<void> =>
        login({
            redirectUri: window.location.origin + pathFn(),
            locale,
            idpHint,
        });
}
